// drawer-ref.ts
import { Subject, Observable } from 'rxjs';

export class DrawerRef<T = any> {
  private afterClosedSubject = new Subject<any>();

  constructor(public drawerData?: T) {}

  close(result?: any) {
    this.afterClosedSubject.next(result);
    this.afterClosedSubject.complete();
  }

  afterClosed(): Observable<any> {
    return this.afterClosedSubject.asObservable();
  }
}
